/**
 * Centralized aria-label and title strings for accessibility.
 *
 * Accessibility pattern (keep for all new UI):
 * - Interactive elements (buttons, icon buttons, custom controls): use aria-label
 *   (or ensure a visible label / aria-labelledby). Use AriaLabel.* for consistency.
 * - Landmarks (nav, main, footer, dialog): use aria-label on the landmark so
 *   screen reader users can jump by region. Navbar/Sidebar/BreadcrumbBar/Modal
 *   already follow this.
 * - Forms: link errors to inputs with aria-describedby pointing to the error
 *   element id; use aria-invalid on the control when invalid.
 * - Decorative icons: use aria-hidden so they are skipped by screen readers.
 */

export const AriaLabel = {
  PrimaryNav: "Primary navigation",
  SecondaryNav: "Secondary navigation",
  Breadcrumb: "Breadcrumb",
  MainContent: "Main content",
  SiteFooter: "Site footer",
  ChatbotMenu: "AI chat quick menu",
  OpenChatbotMenu: "Open AI chat quick menu",
  CloseChatbotMenu: "Close AI chat quick menu",
  OpenAiChat: "Open AI chat",
  Settings: "Settings",
  Profile: "Profile",
  DarkMode: "Dark mode",
  LightMode: "Light mode",
  ExpandSidebar: "Expand sidebar",
  CollapseSidebar: "Collapse sidebar",
  Close: "Close",
  Loading: "Loading",
  Logout: "Logout",
} as const;

export type AriaLabel = (typeof AriaLabel)[keyof typeof AriaLabel];
